import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Calendar, MapPin, Ticket, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import api from '../../lib/api';
import Reveal from '../../components/public/Reveal';

export default function EventosList() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get('/events').then(({ data }) => setEvents(data || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-slate-50">
      <section className="relative overflow-hidden bg-cnib-navy py-20 text-white">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-orange-500">Congresos CNIB</p>
            <h1 className="mt-3 font-heading text-4xl font-extrabold sm:text-5xl">Eventos del sector inmobiliario</h1>
            <p className="mt-3 max-w-2xl text-slate-300">
              Congresos, foros y capacitaciones donde se construye el futuro del mercado inmobiliario boliviano.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="h-10 w-10 animate-spin text-cnib-blue" /></div>
        ) : events.length === 0 ? (
          <div className="rounded-3xl border border-dashed border-slate-300 bg-white py-20 text-center text-slate-500" data-testid="eventos-empty">
            Aún no hay eventos programados. ¡Vuelve pronto!
          </div>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="eventos-grid">
            {events.map((e, i) => (
              <motion.div key={e.slug} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: '-50px' }} transition={{ delay: i * 0.05 }}>
                <Link to={`/eventos/${e.slug}`} data-testid={`evento-card-${e.slug}`} className="group block overflow-hidden rounded-3xl bg-white shadow-lg transition-shadow hover:shadow-2xl">
                  <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                    {e.cover_image ? (
                      <img src={e.cover_image} alt="" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    ) : (
                      <div className="flex h-full items-center justify-center text-6xl font-black text-slate-200">
                        <Calendar className="h-16 w-16" />
                      </div>
                    )}
                  </div>
                  <div className="p-5">
                    <p className="text-[10px] font-bold uppercase tracking-wider text-orange-500">{String(e.starts_at).slice(0, 10)}</p>
                    <p className="mt-1 font-heading text-xl font-extrabold text-slate-900">{e.title}</p>
                    {e.subtitle && <p className="line-clamp-2 mt-1 text-sm text-slate-500">{e.subtitle}</p>}
                    <div className="mt-3 flex items-center gap-3 text-xs text-slate-600">
                      <span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3" /> {e.city}</span>
                      {e.tiers?.length > 0 && (
                        <span className="inline-flex items-center gap-1"><Ticket className="h-3 w-3" /> desde {e.tiers.find((t) => t.is_free) ? 'GRATIS' : `US$ ${Math.min(...e.tiers.map((t) => t.price_usd))}`}</span>
                      )}
                    </div>
                    <span className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-orange-500">
                      Ver detalles <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
